export const ASSESSMENT_TYPES = {
  ITEM_BANK: 'ibx',
  LEGACY_ITEM_BANK: 'legacy_itembank',
  MANUAL_HYBRID: 'manual_hybrid',
  FLEXIBLE: 'flex',
  SKILLS: 'skills'
}
